import { render, staticRenderFns } from "./Prefect.vue?vue&type=template&id=3eddc658&scoped=true&"
import script from "./Prefect.vue?vue&type=script&lang=js&"
export * from "./Prefect.vue?vue&type=script&lang=js&"
import style0 from "./Prefect.vue?vue&type=style&index=0&id=3eddc658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eddc658",
  null
  
)

export default component.exports